import React from "react"

export default function MinusPerson() {
  return (
    <svg fill="none" viewBox="0 0 19 19" height="19" width="19" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1711_8090)">
        <path d="M10.7729 6.27686C10.7729 4.61936 9.43045 3.27686 7.77295 3.27686C6.11545 3.27686 4.77295 4.61936 4.77295 6.27686C4.77295 7.93436 6.11545 9.27686 7.77295 9.27686C9.43045 9.27686 10.7729 7.93436 10.7729 6.27686ZM1.77295 13.7769V14.5269C1.77295 14.9394 2.11045 15.2769 2.52295 15.2769H13.0229C13.4354 15.2769 13.7729 14.9394 13.7729 14.5269V13.7769C13.7729 11.7819 9.77545 10.7769 7.77295 10.7769C5.77045 10.7769 1.77295 11.7819 1.77295 13.7769ZM13.7729 7.77686H16.7729C17.1854 7.77686 17.5229 8.11436 17.5229 8.52686C17.5229 8.93936 17.1854 9.27686 16.7729 9.27686H13.7729C13.3604 9.27686 13.0229 8.93936 13.0229 8.52686C13.0229 8.11436 13.3604 7.77686 13.7729 7.77686Z" fill="#5B5E71" />
      </g>
      <defs>
        <clipPath id="clip0_1711_8090">
          <rect width="18" height="18" fill="white" transform="translate(0.272949 0.276855)" />
        </clipPath>
      </defs>
    </svg>
  )
}
